var _defs, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "130mm",
    height: "130mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 13000 13000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_443218496"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BAC6D4"
    },
    cx: 6475,
    cy: 6452,
    r: 6413
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE",
      fillRule: "nonzero"
    },
    d: "M6905 8873l0 905 -1020 0 0 -905 1020 0zm-3069 -3508c-26,-1193 582,-1935 1399,-2296 334,-148 707,-229 1082,-245 368,-16 740,29 1086,130 891,262 1613,895 1686,1818 93,1172 -659,1720 -1380,2244l-1 -1c-160,116 -319,231 -459,353 -129,112 -213,246 -264,377l0 1c-43,109 -66,217 -77,314l-1027 0c14,-202 53,-444 150,-690l2 0c105,-266 276,-538 547,-774 161,-140 345,-274 528,-407l0 -2c493,-359 1008,-733 960,-1335 -35,-444 -444,-767 -954,-917 -239,-70 -498,-101 -753,-90 -249,11 -495,64 -714,160 -461,205 -805,637 -790,1339l-1021 21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.29ee6ea1811dfa14ef1b0a650cdf96da.svg";
export { ForwardRef as ReactComponent };